import request from '@/utils/request'

/**
 * 查询商品库存
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryProductStock(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.queryProductStock',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询仓库列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopHouse(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopHouse.queryShopHouse',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}